import { render, staticRenderFns } from "./OrdenCompraNoAceptada.vue?vue&type=template&id=732fb84d&"
import script from "./OrdenCompraNoAceptada.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraNoAceptada.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraNoAceptada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports